module.exports = "<captain-finance-page></captain-finance-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appPlans/captainFinance.html
// module id = 1700
// module chunks = 0